import React from "react";

export default function portfolio({ fill }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0004 20.01C10.0019 20.01 10.0035 20.01 10.005 20.01C15.1939 20.01 19.4602 16.0599 19.9609 11.0027L14.9939 11.0027C14.5302 13.3343 12.4728 15.0917 10.005 15.0917C10.0035 15.0917 10.0019 15.0917 10.0004 15.0917L10.0004 20.01ZM15.0913 10.072L20.0098 10.072C20.01 10.0497 20.01 10.0274 20.01 10.005C20.01 4.4794 15.5306 0 10.005 0C10.0035 0 10.0019 3.5238e-07 10.0004 1.05706e-06V4.91833C10.0019 4.91833 10.0035 4.91833 10.005 4.91833C12.8143 4.91833 15.0917 7.19572 15.0917 10.005C15.0917 10.0274 15.0916 10.0497 15.0913 10.072ZM9.06967 19.9669V15.0059C6.70713 14.5668 4.91833 12.4948 4.91833 10.005C4.91833 7.51524 6.70713 5.44325 9.06967 5.00414V0.0431454C3.98262 0.51478 0 4.7948 0 10.005C0 15.2152 3.98262 19.4953 9.06967 19.9669Z"
        fill={fill}
      />
    </svg>
  );
}
